import React from 'react';
import { SectionFade } from './ui/SectionFade';
export function ProblemAgitation() {
  return <section className="py-24 px-4 bg-brand-dark border-t border-white/5" data-id="element-132">
      <div className="max-w-3xl mx-auto" data-id="element-133">
        <SectionFade data-id="element-134">
          <p className="text-xl md:text-2xl font-inter font-light leading-relaxed text-gray-300 mb-8" data-id="element-135">
            ¿Alguna vez has sentido que, sin importar cuánto te esfuerces por
            comer "sano", siempre terminas con pesadez, falta de energía o sin
            ver resultados?{' '}
            <strong className="text-white font-semibold" data-id="element-136">
              No es tu falta de voluntad.
            </strong>{' '}
            Es que estás siendo víctima de un sistema diseñado para engañarte.
          </p>
        </SectionFade>

        <SectionFade delay={0.1} data-id="element-137">
          <p className="text-xl md:text-2xl font-inter font-light leading-relaxed text-gray-300 mb-12" data-id="element-138">
            La industria alimentaria gasta miles de millones en neuromarketing
            para que ignores la etiqueta y solo mires el frontal del envase. Te
            venden <span className="text-white font-medium" data-id="element-139">"0% Grasa"</span>,{' '}
            <span className="text-white font-medium" data-id="element-140">"Natural"</span> y{' '}
            <span className="text-white font-medium" data-id="element-141">"Multigrano"</span>{' '}
            mientras esconden ingredientes que destrozan tu metabolismo en la
            letra pequeña.
          </p>
        </SectionFade>

        <SectionFade delay={0.2} data-id="element-142">
          <div className="bg-red-950/30 border-l-4 border-red-500 p-6 md:p-8 rounded-r-lg" data-id="element-143">
            <p className="font-bebas text-3xl md:text-5xl text-white tracking-wide leading-tight" data-id="element-144">
              Estás pagando por salud y te están entregando{' '}
              <span className="text-red-500" data-id="element-145">inflamación envasada.</span>
            </p>
          </div>
        </SectionFade>
      </div>
    </section>;
}